import React from "react";
import styles from "./threshold-fields.module.scss";
import { CheckBoxWithText } from "@src/components/atoms/check-box-with-text/check-box-with-text";

const cssClassName = "threshold-fields";

/** Wording for the fieldset. Each editor passes its own module's strings, so
 *  this component carries no translations of its own. */
export interface ThresholdFieldsTexts {
  thresholdLabel: string;
  warningLabel: string;
  criticalLabel: string;
}

interface ThresholdFieldsProps {
  texts: ThresholdFieldsTexts;
  warningEnabled: boolean;
  warningValue: string;
  onWarningEnabledChange: (enabled: boolean) => void;
  onWarningValueChange: (value: string) => void;
  criticalEnabled: boolean;
  criticalValue: string;
  onCriticalEnabledChange: (enabled: boolean) => void;
  onCriticalValueChange: (value: string) => void;
}

/**
 * The warning / critical threshold pair the gauge and the line charts show.
 * Dumb on purpose: it renders what it is given and reports every toggle and
 * keystroke back, so each editor keeps its own state and its own validation.
 */
export const ThresholdFields = ({
  texts,
  warningEnabled,
  warningValue,
  onWarningEnabledChange,
  onWarningValueChange,
  criticalEnabled,
  criticalValue,
  onCriticalEnabledChange,
  onCriticalValueChange,
}: ThresholdFieldsProps) => (
  <fieldset className={styles[`${cssClassName}__thresholds`]}>
    <legend className={styles[`${cssClassName}__field-label`]}>
      {texts.thresholdLabel}
    </legend>

    <div className={styles[`${cssClassName}__threshold-row`]}>
      <CheckBoxWithText
        text={texts.warningLabel}
        checkboxState={warningEnabled}
        handleCheckBoxClick={() => onWarningEnabledChange(!warningEnabled)}
      />
      {warningEnabled && (
        <input
          type="text"
          className={styles[`${cssClassName}__input`]}
          placeholder={texts.warningLabel}
          value={warningValue}
          onChange={(event) => onWarningValueChange(event.target.value)}
        />
      )}
    </div>

    <div className={styles[`${cssClassName}__threshold-row`]}>
      <CheckBoxWithText
        text={texts.criticalLabel}
        checkboxState={criticalEnabled}
        handleCheckBoxClick={() => onCriticalEnabledChange(!criticalEnabled)}
      />
      {criticalEnabled && (
        <input
          type="text"
          className={styles[`${cssClassName}__input`]}
          placeholder={texts.criticalLabel}
          value={criticalValue}
          onChange={(event) => onCriticalValueChange(event.target.value)}
        />
      )}
    </div>
  </fieldset>
);
